import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import urlJoin from 'url-join';
import { SettingsService } from '../shared/services/settings/settings.service';
import { BankNotificationCode } from './bank-notification-code.model';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class BankNotificationCodeService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService) { }

  getCodes(): Observable<BankNotificationCode[]> {
    const url = this._getUri('bankNotificationCodes/allExceptPaymentVoidedAndUndoVoided', this.settings.tenantId);
    return this.http.get<BankNotificationCode[]>(url);
  }

  private _getUri(path: string, tenantId: string) {
    return urlJoin(ROUTE_TOKEN_GATEWAY_URL, `cui-payment/v1/tenants/${encodeURI(tenantId)}`, path);
  }
}
